import Swiper, { Navigation, Pagination, Autoplay, Lazy } from 'swiper';
Swiper.use([Pagination, Navigation, Autoplay, Lazy]);

const initPaymentSlider = () => {
  const sliderContainer_1 = document.querySelector('.payment-slider-1'),
    sliderContainer_2 = document.querySelector('.payment-slider-2');

  new Swiper(sliderContainer_1, {
    speed: 5000,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    loop: true,

    breakpoints: {
      1024: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
      0: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
    },
  });

  new Swiper(sliderContainer_2, {
    speed: 6000,
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
      reverseDirection: true,
    },
    loop: true,

    breakpoints: {
      1024: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
      0: {
        slidesPerView: 2,
        spaceBetween: 40,
      },
    },
  });
};

export default initPaymentSlider;
